<template>
    <div class="ai-chat-header flex items-center justify-between px-4 py-3 border-b border-gray-200 bg-white">
        <div class="flex items-center min-w-0 flex-1 mr-2">
            <button
                v-if="showBack"
                class="mr-2 text-muted hover:text-gray-700 flex-shrink-0"
                @click="$emit('back')"
            >
                <i class="far fa-arrow-left fa-fw"></i>
            </button>
            <i class="far fa-tint fa-fw text-blue-500 mr-2 flex-shrink-0"></i>
            <input
                v-if="isEditing"
                ref="titleInput"
                v-model="editTitle"
                class="font-semibold text-gray-800 border border-blue-400 rounded px-1 py-0 text-sm w-full focus:outline-none"
                maxlength="100"
                @keydown.enter="saveTitle"
                @keydown.escape="cancelEdit"
                @blur="saveTitle"
            >
            <span
                v-else
                class="font-semibold text-gray-800 truncate cursor-pointer hover:text-blue-600"
                :title="editable ? 'Click to rename' : title"
                @click="startEdit"
            >{{ title }}</span>
        </div>
        <div class="flex items-center flex-shrink-0">
            <div
                v-if="showViewModes"
                class="flex items-center border border-gray-200 rounded-md mr-2 overflow-hidden"
            >
                <button
                    v-tooltip="'Sidebar - pushes content'"
                    class="px-2 py-1 text-xs border-r border-gray-200"
                    :class="viewMode === 'sidebar' ? 'bg-blue-100 text-blue-600' : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'"
                    @click="$emit('changeMode', 'sidebar')"
                >
                    <i class="fas fa-columns"></i>
                </button>
                <button
                    v-tooltip="'Overlay - floats over content'"
                    class="px-2 py-1 text-xs"
                    :class="viewMode === 'overlay' ? 'bg-blue-100 text-blue-600' : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'"
                    @click="$emit('changeMode', 'overlay')"
                >
                    <i class="fas fa-window-maximize"></i>
                </button>
            </div>
            <button
                v-if="showNewChat"
                v-tooltip="'New Chat'"
                class="text-muted hover:text-gray-700 mr-2"
                @click="$emit('newChat')"
            >
                <i class="far fa-plus fa-fw"></i>
            </button>
            <button
                v-tooltip="'Minimize'"
                class="text-muted hover:text-gray-700"
                @click="$emit('close')"
            >
                <i class="far fa-times fa-fw"></i>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: 'Droplet',
        },
        showBack: {
            type: Boolean,
            default: false,
        },
        showNewChat: {
            type: Boolean,
            default: false,
        },
        viewMode: {
            type: String,
            default: 'overlay',
        },
        showViewModes: {
            type: Boolean,
            default: true,
        },
        editable: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isEditing: false,
            editTitle: '',
        };
    },

    methods: {
        startEdit() {
            if (!this.editable) return;

            this.editTitle = this.title;
            this.isEditing = true;
            this.$nextTick(() => {
                this.$refs.titleInput.focus();
                this.$refs.titleInput.select();
            });
        },

        saveTitle() {
            if (!this.isEditing) return;

            const newTitle = this.editTitle.trim();
            this.isEditing = false;

            if (newTitle && newTitle !== this.title) {
                this.$emit('rename', newTitle);
            }
        },

        cancelEdit() {
            this.isEditing = false;
        },
    },
};
</script>
